/**
 * Represents the symbol for the CommentsSelectService.
 */
export const CommentsSelectService = Symbol('CommentsSelectService');
